// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";
import TitleBar from "src/components/base/title-bar/TitleBar";

// Sub-Components
import ExceprinceCardGroup from "./com/ExceprinceCardGroup";

// Data / Images / Icons

function P_Experience() {
  return (
    <DefaultLayout>
      <TitleBar />

      <ExceprinceCardGroup />
    </DefaultLayout>
  );
}

export default P_Experience;
